<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <h1 class="title text-xs-center">Новости</h1>
          <div class="messages">
            <div v-for="n in news" :key="n.id">
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="subheading mb-0">{{ n.title }}</h3>
                    <div>{{ new Date(n.publishDate).toLocaleDateString() }}</div>
                  </div>
                </v-card-title>
                <v-card-text v-html="n.text"></v-card-text>
              </v-card>
              <v-divider></v-divider>
            </div>
            <v-btn color="info" to="/news-archive">Архив новостей</v-btn>
          </div>
        </v-flex>
        <v-flex xs12 md5 offset-md1>
          <h1 class="title text-xs-center">Анонсы</h1>
          <div class="messages">
            <div v-for="a in announcement" :key="a.id">
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="subheading mb-0">{{ a.title }}</h3>
                  </div>
                </v-card-title>
                <v-card-text v-html="a.text"></v-card-text>
              </v-card>
              <v-divider></v-divider>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md2 offset-md1>
          <h1 class="title text-xs-center">Адреса секций</h1>
          <div class="messages">
            <div v-for="sec in sections" :key="sec.id">
              <v-card>
                <v-card-title primary-title>
                  <div>
                    <h3 class="subheading mb-0 metro">
                      <router-link :to="{path: '/addresses', hash: '2'}">{{ sec.name }}</router-link>
                    </h3>
                  </div>
                </v-card-title>
              </v-card>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VueAnchorRouterLink from "vue-anchor-router-link";
import api from "../api";

export default {
  components: {
    VueAnchorRouterLink
  },
  data() {
    return {
      news: [],
      announcement: [],
      error: "",
      sections: []
    };
  },
  async created() {
    try {
      this.error = null;
      this.news = await api.getTopPublishedNews();
      this.announcement = await api.getVisibleAnnouncements();
      this.sections = await api.getActiveSections();
    } catch (error) {
      this.error = error.response.data;
    }
  },
  methods: {
    getSectionLink(section) {
      return `/addresses#${section.id}`;
    }
  }
};
</script>

<style scoped>
.messages {
  margin-top: 20px;
}
.metro:before {
  content: "";
  background: url("../assets/m.gif") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  float: left;
  margin: 0 6px 0 0;
}
</style>

